import { render, staticRenderFns } from "./MyBoardsPopoverItem.vue?vue&type=template&id=396e6dcb&"
import script from "./MyBoardsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./MyBoardsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports